/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The provider's location information.
 * @export
 * @interface HotelContentProviderGeocodes
 */
export interface HotelContentProviderGeocodes {
    /**
     * Latitude
     * @type {number}
     * @memberof HotelContentProviderGeocodes
     */
    lat?: number;
    /**
     * Longitude
     * @type {number}
     * @memberof HotelContentProviderGeocodes
     */
    _long?: number;
}

/**
 * Check if a given object implements the HotelContentProviderGeocodes interface.
 */
export function instanceOfHotelContentProviderGeocodes(value: object): value is HotelContentProviderGeocodes {
    return true;
}

export function HotelContentProviderGeocodesFromJSON(json: any): HotelContentProviderGeocodes {
    return HotelContentProviderGeocodesFromJSONTyped(json, false);
}

export function HotelContentProviderGeocodesFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelContentProviderGeocodes {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['Lat'] == null ? undefined : json['Lat'],
        '_long': json['Long'] == null ? undefined : json['Long'],
    };
}

export function HotelContentProviderGeocodesToJSON(json: any): HotelContentProviderGeocodes {
    return HotelContentProviderGeocodesToJSONTyped(json, false);
}

export function HotelContentProviderGeocodesToJSONTyped(value?: HotelContentProviderGeocodes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Lat': value['lat'],
        'Long': value['_long'],
    };
}

